exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chat-container {\n  width: 100%; }\n\nh2 {\n  font-size: 1em;\n  font-weight: normal;\n  margin: 0;\n  padding: 1.5rem;\n  opacity: .5; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/folder/folder-view/folder-view-mobile/folder-view-mobile.component.scss
// module id = ../../../../../src/app/folder/folder-view/folder-view-mobile/folder-view-mobile.component.scss
// module chunks = main